// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3JYYI","Open":"SideDrawer_Open__4FM26","Close":"SideDrawer_Close__1ftDH","Logo":"SideDrawer_Logo__dEXYp"};